export default __webpack_public_path__ + "static/media/java-dev.7015ee1e.jpg";